export default __webpack_public_path__ + "2ec28991b7b2dc248fd1c49ff72e5ac5.js";